import { render } from "./AppAlert.vue?vue&type=template&id=699075d8&ts=true"
import script from "./AppAlert.vue?vue&type=script&lang=ts"
export * from "./AppAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__